var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.75 9.88372C29.75 8.3893 29.157 6.95656 28.1002 5.89979C27.0434 4.84302 25.6107 4.25 24.1163 4.25H9.88372C8.3893 4.25 6.95656 4.84302 5.89979 5.89979C4.84302 6.95656 4.25 8.3893 4.25 9.88372V24.1163C4.25 25.6107 4.84302 27.0434 5.89979 28.1002C6.95656 29.157 8.3893 29.75 9.88372 29.75H24.1163C25.6107 29.75 27.0434 29.157 28.1002 28.1002C29.157 27.0434 29.75 25.6107 29.75 24.1163V9.88372ZM17.5788 12.4491L14.7323 20.9887C14.5781 21.4548 14.8295 21.9589 15.2957 22.1142C15.7618 22.2684 16.2658 22.017 16.4212 21.5509L19.2677 13.0113C19.4219 12.5452 19.1705 12.0411 18.7043 11.8858C18.2382 11.7316 17.7342 11.983 17.5788 12.4491ZM20.6412 14.7821L22.8579 17L20.6412 19.2179C20.2936 19.5642 20.2936 20.1288 20.6412 20.4751C20.9875 20.8226 21.552 20.8226 21.8984 20.4751L24.7449 17.6286C25.0924 17.2811 25.0924 16.7189 24.7449 16.3714L21.8984 13.5249C21.552 13.1774 20.9875 13.1774 20.6412 13.5249C20.2936 13.8712 20.2936 14.4358 20.6412 14.7821ZM12.1016 13.5249L9.25512 16.3714C8.9076 16.7189 8.9076 17.2811 9.25512 17.6286L12.1016 20.4751C12.448 20.8226 13.0125 20.8226 13.3588 20.4751C13.7063 20.1288 13.7063 19.5642 13.3588 19.2179L11.1421 17L13.3588 14.7821C13.7063 14.4358 13.7063 13.8712 13.3588 13.5249C13.0125 13.1774 12.448 13.1774 12.1016 13.5249Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeHover);
export default __webpack_public_path__ + "static/media/codeHover.1b61ad6f4934d0cae10e9ac6aaeec231.svg";
export { ForwardRef as ReactComponent };